import styled from "styled-components";
import Radio from "antd/lib/radio";

export const StyledRadioButton = styled(Radio)`
  color: ${({ checked, theme }) => checked && theme.primaryColor};
  transition: color 0.3s;
  display: block;
`;
